// extracted by mini-css-extract-plugin
module.exports = {"grey200":"#E6E6EC","wrapper":"Appstores_wrapper__dJlrY","container":"Appstores_container__8a2og","content":"Appstores_content__BMKI7","divider":"Appstores_divider__aBCur"};